"use strict";

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyTooltip = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledTooltip = (0, material_1.styled)(_a => {
  var {
    className
  } = _a,
      props = __rest(_a, ["className"]);

  return react_1.default.createElement(material_1.Tooltip, Object.assign({}, props, {
    classes: {
      popper: className
    }
  }));
})({
  [`& .${material_1.tooltipClasses.tooltip}`]: {
    opacity: 1,
    fontSize: 12,
    padding: "6px 8px",
    fontWeight: 300 // textTransform: "capitiliaze" - Was capitiliazed and now no text transform

  }
});

const SskyTooltip = props => {
  const popperProps = Object.assign({
    style: {
      left: props.left
    }
  }, props.PopperProps);
  return react_1.default.createElement(StyledTooltip, {
    id: props.id,
    className: props.className,
    title: props.title,
    placement: props.placement,
    enterDelay: props.enterDelay,
    leaveDelay: props.leaveDelay,
    PopperProps: popperProps,
    "data-testid": props.dataTestId || `testId-${props.id}`
  }, props.children);
};

exports.SskyTooltip = SskyTooltip;
exports.default = react_1.default.memo(SskyTooltip);